module.exports = __webpack_public_path__ + "static/media/rigid-truck.59629a28.svg";